import React from 'react';
import { useSelector } from 'react-redux';
import { CompanyPubrSelectors } from '@panel/usuarios/src/store/ducks/myCompany';
import ModalWithTimer from './ModalWithTimer';
import { RedirectMessage } from './redirectMessage';
import { ContactOwnerModal } from '../contactOwner';

const PuerModalType = ({
  redirectPublisher,
  breakpoint,
  siteId,
  publisherId,
  isPublisherMasked,
  setRedirectPublisher
}) => {
  const { modal } = useSelector(CompanyPubrSelectors.getCompanyPubr);
  const Timer = () => {
    return (
      <ModalWithTimer time={redirectPublisher ? '6000' : null} breakpoint={breakpoint} noAnimation={redirectPublisher}>
        <RedirectMessage
          isPublisherMasked={isPublisherMasked}
          portalDestiny={siteId}
          userPublisherId={publisherId}
          handleAction={setRedirectPublisher}
        />
      </ModalWithTimer>
    );
  };

  const Owner = () => {
    return <ContactOwnerModal />;
  };
  const type = { timer: <Timer />, owner: <Owner /> };

  return <>{type[modal]}</>;
};

export default PuerModalType;
